import { graphql, httpClient, resolveApiUrl } from '#shared/api'
import IsHasCurrentOrdersResponse from '../model/has-current-orders-response'

export default async function getHasCurrentOrders() {
  const currentStatuses = '[PURCHASED, ARRIVING, PROCESSING]'

  const response = await httpClient.post<IsHasCurrentOrdersResponse>(resolveApiUrl('@sd-orders'), {
    json: graphql(`
      query {
        ordersByClientIds(first: 1, where: { status: { in: ${currentStatuses} } }) {
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
        }
      }`),
  })

  const responseBody = await response.json()

  return responseBody.data.ordersByClientIds.pageInfo.startCursor !== null
}
